import dateFormat from "dateformat";

export default {
    getInitials(name) {
        var initials = name.match(/\b\w/g) || [];
        initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
        return initials;
    },
    addCommas(value) {
        if(value != undefined)
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    removeCommas(value) {
        if (value != undefined)
            return value.replace(/,/g, "")
    },
    stripeToJSDate(timestamp) {
        return new Date(timestamp * 1000);
    },
    formatDate(date) {
        return date.toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' });
    },

    getUsersFullName({ firstName = '', lastName = ''}) {
        let fullName = '';
        fullName = firstName.trim() + ' ' + lastName.trim();
        return fullName;
    },
    getTelephoneCodeFromCountry (telephoneCodes, country) {
        for(let i = 0; i < telephoneCodes.length; i ++) {
            if(telephoneCodes[i].name.toLowerCase() == country.toLowerCase()) {
                return telephoneCodes[i];
            }    
        }
        return {countryCode: 'AU', number: '+61'};
    },
    dateDiffInDays(a, b) {
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    },
    openTermsOfUseUrl() {
        window.open(this.termsOfUseUrl);
    },
    openPrivacyPolicyUrl() {
        window.open(this.privacyPolicyUrl);
    },
    openPricingUrl() {
        window.open(this.pricingUrl);
    },
    //Start: Added by dubey
    domainUriPrefix() {
        return this.$appHostUrl;
    },
    domainBPUriPrefix() {
        return process.env.NODE_ENV == 'production'? "https://business.pappyon.com" : "https://pappyonstaging.web.app";
    },
    androidPackageName() {
        return process.env.NODE_ENV == "production" ? "com.pappyon.app" : "com.pappyon.app.dev";
    },
    iOSBundleId() {
        return process.env.NODE_ENV == "production" ? "com.pappyon.app" : "com.pappyon.app.dev";
    },
    firebaseWebAPIKey() {
        return process.env.NODE_ENV == "production"
        ? "AIzaSyCtZC_Sg48yt07uF8UgOtvfmtH41ECKaCM"
        : "AIzaSyC3T43-Es6RF5w_c-roI_Zc_2hO5NQxv3A";
    },
    async copyToClipboard(text) {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        }
    },
    formatDateTime(dateTime) {

        return (
          dateFormat(dateTime
            , "mediumDate") +
          " " +
          dateFormat(dateTime, "shortTime")
        );
    },
    //End: Added by dubey
    getSubscriptionPlanFromQueryString(queryString) {
        let plan = '';
        if (queryString.toLowerCase() == 'grow')
            plan = 'grow';
        else
            plan = 'evolve';
        return plan;
    },

    getSubscriptionPlanTitle(value) {
        let title = '';
        if (value == undefined || value == 'grow')
            title = 'Grow - For Business';
        else
            title = 'Evolve - For Business + Events';
        return title;
    },
    webAppLinkPrefix(){
        return process.env.NODE_ENV == 'production'? "https://app.pappyon.com/" : "https://app-staging-pappyon.web.app/";
    },
    addWorkDays(startDateString, days) {

        let startDate = new Date(startDateString);

        if(isNaN(days)) {
            console.log("Value provided for \"days\" was not a number");
            return
        }
        if(!(startDate instanceof Date)) {
            console.log("Value provided for \"startDate\" was not a Date object");
            return
        }
        // Get the day of the week as a number (0 = Sunday, 1 = Monday, .... 6 = Saturday)
        var dow = startDate.getDay();
        var daysToAdd = parseInt(days);
        // If the current day is Sunday add one day
        if (dow == 0)
            daysToAdd++;
        // If the start date plus the additional days falls on or after the closest Saturday calculate weekends
        if (dow + daysToAdd >= 6) {
            //Subtract days in current working week from work days
            var remainingWorkDays = daysToAdd - (5 - dow);
            //Add current working week's weekend
            daysToAdd += 2;
            if (remainingWorkDays > 5) {
                //Add two days for each working week by calculating how many weeks are included
                daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
                //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks
                if (remainingWorkDays % 5 == 0)
                    daysToAdd -= 2;
            }
        }
        startDate.setDate(startDate.getDate() + daysToAdd);

       
        return startDate;
    },
    allowIntegers(event) {
        let ASCIICode = event.which ? event.which : event.keyCode;
    
        //Only allow ASCII codes within number range
        if (ASCIICode == 8) {
          return true;
        } else {
          if (48 <= ASCIICode && ASCIICode <= 57) {
            return true;
          } else {
            return false;
          }
        }
      },
}